export default __webpack_public_path__ + "static/media/milestone 3000.3cc63751.svg";